export const HOST_PROJECTS_QUERY_KEYS = {
  all: ['host-projects'] as const,
  byHost: (hostId: string) => ['host-projects', hostId] as const,
} as const
